import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=template&id=7d73b278&scoped=true"
import script from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d73b278",
  null
  
)

export default component.exports